import { ADVISOR_HEADSHOT_SIZES } from '../../../utils/advice/advice-utility';

export const getHeadshotRequestStatus = (state) => {
  return {
    isIdle: state.advisorHeadshot.isIdle,
    isLoaded: state.advisorHeadshot.isLoaded,
    isLoading: state.advisorHeadshot.isLoading,
    hasFailed: state.advisorHeadshot.hasFailed,
  };
};
export const getNormalAdvisorHeadshot = (state) => {
  const rendition =
    state.advisorHeadshot?.data?.dmRenditions?.smartCropRenditions?.find(
      (r) => r.smartCropDef === ADVISOR_HEADSHOT_SIZES.NORMAL1
    );
  return rendition?.imageURL;
};
